module.exports = __webpack_public_path__ + "static/media/pixelLogo.24e72cce.png";